import { render } from "./LeaguesList.vue?vue&type=template&id=74941c4a&scoped=true"
import script from "./LeaguesList.vue?vue&type=script&lang=js"
export * from "./LeaguesList.vue?vue&type=script&lang=js"

import "./LeaguesList.vue?vue&type=style&index=0&id=74941c4a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74941c4a"]])

export default __exports__